<template>
  <div class="room-setting-streaming-component p-5">
    <div class="room-setting-content-box">
      <h6 class="room-setting-content-title">{{this.$t('setting.streaming.title')}}</h6>
      <div class="room-setting-content-text-box">
        <p class="room-setting-content-text">{{this.$t('setting.streaming.text')}}</p>
      </div>
      <div class="room-setting-input-box">
        <label class="room-setting-label">
          <input type="checkbox" class="room-setting-radio" name="youtubeStreaming" value="youtube">
          <span>Youtube</span>
        </label>
      </div>
      <div class="room-setting-input-box">
        <input type="text" name="youtubeStreamingKey" class="room-setting-input" placeholder=""/>
      </div>
      <div class="room-setting-input-box">
        <label class="room-setting-label">
          <input type="checkbox" class="room-setting-radio" name="facebookStreaming" value="facebook">
          <span>facebook</span>
        </label>
      </div>
      <div class="room-setting-input-box">
        <input type="text" name="facebookStreamingKey" class="room-setting-input" placeholder=""/>
      </div>
      <div class="room-setting-input-box">
        <label class="room-setting-label">
          <input type="checkbox" class="room-setting-radio" name="externalStreaming" value="etc">
          <span>기타</span>
        </label>
      </div>
      <div class="room-setting-input-box">
        <input type="text" name="externalStreamingUrl" class="room-setting-input" placeholder="URL"/>
      </div>
      <div class="room-setting-input-box">
        <input type="text" name="externalStreamingKey" class="room-setting-input" placeholder=""/>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {
  },
  data(){
    return{
      roomTitle: '2022e1',
      isPublic: true,
      titleMessage: '방 이름은 한글, 영문, 숫자, 띄어쓰기, <br>특수문자(-) 만 가능합니다.'
    }
  },
  methods:{
    onChangePublicMode(){
      console.log(this.isPublic);
    }
  }
}
</script>

<style lang='scss' scoped>

</style>